import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '../../store'
import { BreadcrumbI, MainProps } from '../../../types-interfaces/interfaces'



const initialState: MainProps = {
  breadCrumbs: [],  
}

export const mainSlice = createSlice({
  name: 'breadCrums',
  initialState: initialState,
  reducers: {
    setBreadCrumbs: (state, action: PayloadAction<Array<BreadcrumbI>>) => {
      state.breadCrumbs = action.payload;
    }
  },
})

export const { setBreadCrumbs } = mainSlice.actions;
export const selectBreadCrumbs = (state: RootState) => state.mainState.breadCrumbs;
export default mainSlice.reducer;